const state = {
  selectedDate: null,
  currSubInfo: null
}

const mutations = {
  updateSelectedDate (state, date) {
    state.selectedDate = date
  },
  updateCurrSubInfo (state, info) {
    state.currSubInfo = info
  },
  clearCurrSubInfo (state) {
    state.currSubInfo = null
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
